import { useMutation, useQueryClient } from "@tanstack/react-query";
import { setGameTags, type SetGameTagsParams } from "./setGameTags";
import { CASINO_CONFIGURATION_GAMES_SCOPE_QUERY_KEY } from "./casinoConfigurationGamesQueryKeys";

export function useSetGameTags() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (params: SetGameTagsParams) => setGameTags(params),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: CASINO_CONFIGURATION_GAMES_SCOPE_QUERY_KEY,
      });
      void queryClient.invalidateQueries({
        queryKey: ["casinoConfiguration", "collections"],
      });
    },
  });
}
